import { render, staticRenderFns } from "./VisualSearch.vue?vue&type=template&id=bcd72ba0&"
import script from "./VisualSearch.vue?vue&type=script&lang=js&"
export * from "./VisualSearch.vue?vue&type=script&lang=js&"
import style0 from "./VisualSearch.vue?vue&type=style&index=0&id=bcd72ba0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports